module.exports = __webpack_public_path__ + "assets/images/regular.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/regular.png
// module id = 256
// module chunks = 1